import React from 'react';
import { NavLink } from 'react-router-dom';
import {  trans } from '../utils';
const LeftSideBarItem = ({Toggle,setNavigate,MenuItem}) => {

    return (<div onClick={(e) => {
        e.stopPropagation();
    }} className="menu-item"  >
        <NavLink className="menu-link" activeClassName='active' to={'/' + MenuItem.route}>
                                        <span className="menu-icon">
                                            <i className={MenuItem.icon}></i>
                                        </span>
            <span className="menu-title">{trans(MenuItem.name_en)}</span>
        </NavLink>
    </div>);
}
export default LeftSideBarItem;
